import { render, staticRenderFns } from "./addFacilitys.vue?vue&type=template&id=c2029f34"
import script from "./addFacilitys.vue?vue&type=script&lang=js"
export * from "./addFacilitys.vue?vue&type=script&lang=js"
import style0 from "./addFacilitys.vue?vue&type=style&index=0&id=c2029f34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports